<template>
  <div class="ui-pg-selection" :class="{ 'ui-pg-selection--in-app' : $inApp }">
    <div class="ui-intro__content">
      <div class="content__slider slider">
        <div
          class="slider__image-container"
          :style="{ background: pgs[0].gradient }"
          @click="clickBg"
        >
          <transition @enter="enter" @leave="leave" :css="false" mode="out-in">
            <img
              :key="index"
              :src="`${pgs[index].img}.${pgs[index].unlocked ? 'gif' : 'png'}`"
              :alt="pgs[index].name"
            >
          </transition>
        </div>

        <div class="slider__tag" :style="{ 'background-color': pgs[0].tagColor }" :data-index="index">
          <transition @enter="enterTag" @leave="leaveTag" :css="false" mode="out-in">
            <p :key="index">{{ pgs[index].name }}</p>
          </transition>
        </div>

        <transition @enter="enterCondition" @leave="leaveCondition" :css="false" mode="out-in">
          <div
            v-if="this.index === 1 && !pgs[1].unlocked"
            :key="1"
            class="slider__condition slider__condition--blueberries"
            :style="{ 'background-color': pgs[1].tagColor }"
          >
            <p>{{ $translate('unlock') }}</p>

            <div>
              <img src="/img/tutorial/tutorial-fruit-01.png" alt="Blueberries image"> {{ $store.state.userData.data.blueberries }}/15
            </div>
          </div>
          <div
            v-else-if="this.index === 2 && !pgs[2].unlocked"
            :key="2"
            class="slider__condition slider__condition--strawberries"
            :style="{ 'background-color': pgs[2].tagColor }"
          >
            <p>{{ $translate('unlock') }}</p>

            <div>
              <img src="/img/tutorial/tutorial-fruit-00.png" alt="Strawberries image"> {{ $store.state.userData.data.strawberries }}/30
            </div>
          </div>
          <div
            v-else-if="this.index === 3 && !pgs[3].unlocked"
            :key="3"
            class="slider__condition slider__condition--mt"
            :style="{ 'background-color': pgs[3].tagColor }"
          >
            <p>{{ $translate('unlock') }}</p>

            <div>m {{ $store.state.userData.data.mt }}/5000</div>
          </div>
        </transition>

        <button
          class="slider__arrow slider__arrow--prev"
          @click="changeIndex(-1)"
        >
          <img src="/assets/svg/arrow-left.svg" alt="Arrow left go to prev character">
        </button>
        <button
          class="slider__arrow slider__arrow--next"
          @click="changeIndex(1)"
        >
          <img src="/assets/svg/arrow-right.svg" alt="Arrow right go to next character">
        </button>
      </div>

      <!-- <p class="pg-selection__text">{{ $translate('pgSelection') }}</p> -->

      <ButtonRounded
        ref="button"
        class="content__button"
        :class="{ 'content__button--inactive' : !pgs[this.currentIndex].unlocked }"
        :style="{ pointerEvents: pgs[this.currentIndex].unlocked ? 'auto' : 'none' }"
        :content="$translate('run')"
        :skin="pgs[index].id"
        :action="pgs[this.currentIndex].unlocked ? this.$store.state.tutorialDone ? 'play' : 'startTutorial' : 'no_action'"
      />
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import ButtonRounded from '@/components/ButtonRounded.vue';

export default {
  name: 'PgSelection',

  components: {
    ButtonRounded,
  },

  data() {
    return {
      index: 0,
      currentIndex: 0,
      direction: '',
      inTransition: false,
      pgs: [
        {
          id: 'yellow',
          tagColor: 'rgb(255, 112, 240)',
          name: 'Yve',
          img: '/img/pg/pg-yellow',
          gradient: 'linear-gradient(145deg, rgb(12, 229, 100) 35%, rgb(158, 245, 231) 100%)',
          unlocked: true,
        },
        {
          id: 'azure',
          tagColor: 'rgb(171, 179, 85)',
          name: 'Lucy',
          img: '/img/pg/pg-azure',
          gradient: 'linear-gradient(145deg, rgb(130, 255, 251) 35%, rgb(237, 244, 79) 100%)',
          unlocked: this.$store.state.userData.data.blueberries && parseInt(this.$store.state.userData.data.blueberries, 10) >= 15,
        },
        {
          id: 'violet',
          tagColor: 'rgb(64, 118, 127)',
          name: 'Polly',
          img: '/img/pg/pg-violet',
          gradient: 'linear-gradient(145deg, rgb(130, 255, 251) 35%, rgb(15, 154, 147) 100%)',
          unlocked: this.$store.state.userData.data.strawberries && parseInt(this.$store.state.userData.data.strawberries, 10) >= 30,
        },
        {
          id: 'rainbow',
          tagColor: 'rgb(173, 127, 227)',
          name: 'Sam',
          img: '/img/pg/pg-rainbow',
          gradient: 'linear-gradient(145deg, rgb(132, 158, 242) 35%, rgb(158, 245, 231) 100%)',
          unlocked: this.$store.state.userData.data.mt && parseInt(this.$store.state.userData.data.mt, 10) >= 5000,
        },
      ],
    };
  },

  methods: {
    clickBg() {
      this.$refs.button.$el.click();
    },
    changeIndex(i) {
      if (this.inTransition) return;
      this.inTransition = true;

      if (i > 0) {
        this.direction = 'next';
        this.index = this.index + 1 === this.pgs.length ? 0 : this.index + 1;
      } else {
        this.direction = 'prev';
        this.index = this.index - 1 < 0 ? this.pgs.length - 1 : this.index - 1;
      }
    },
    enterCondition(el, done) {
      gsap.from(el, {
        autoAlpha: 0,
        duration: 0.5,
        delay: 0.5,
        onComplete: done,
      });
    },
    leaveCondition(el, done) {
      gsap.to(el, { autoAlpha: 0, duration: 0.5, onComplete: done });
    },
    enterTag(el, done) {
      const tl = gsap.timeline({ onComplete: done });

      tl.addLabel('start')
        .from(el, {
          y: 15,
          autoAlpha: 0,
          duration: 1,
          ease: 'flap',
        }, 'start');
    },
    leaveTag(el, done) {
      gsap.to(el, {
        y: -15,
        autoAlpha: 0,
        duration: 0.5,
        ease: 'power3.in',
        onComplete: done,
      });

      gsap.to('.ui-pg-selection .slider__tag', {
        backgroundColor: this.pgs[this.index].tagColor,
        duration: 1,
        ease: 'power3.in',
      });
    },
    enter(el, done) {
      gsap.fromTo(el, {
        xPercent: this.direction === 'next' ? 50 : -50,
        yPercent: -50,
        autoAlpha: 0,
      },
      {
        xPercent: 0,
        yPercent: -50,
        autoAlpha: 1,
        duration: 0.5,
        ease: 'flap',
        onComplete: () => {
          done();
          this.inTransition = false;
        },
      });
    },
    leave(el, done) {
      gsap.to(el, {
        xPercent: this.direction === 'next' ? -50 : 50,
        autoAlpha: 0,
        duration: 0.5,
        ease: 'power3.in',
        onComplete: () => {
          this.currentIndex = this.index;
          done();
        },
      });

      gsap.to('.ui-pg-selection .slider__image-container', {
        background: this.pgs[this.index].gradient,
        duration: 1,
        ease: 'power3.in',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-pg-selection {
  pointer-events: auto;
  padding-bottom: 8vh;

  display: flex;
  align-items: flex-end;
  justify-content: center;

  text-align: center;
  color: $color-yellow;

  .content__button--inactive {
    color: rgba($color-white, 0.25);
  }

  &:not(.ui-pg-selection--in-app) {
    @include mq($and: $is-height-small) {
      padding-bottom: 5vh;

      .slider {
        margin-bottom: 9vh;
      }
    }
  }

  .slider {
    position: relative;
    width: 60vw;
    max-width: 225px;
    height: 43vh;
    max-height: 350px;
    margin-bottom: 11vh;

    border: solid 1px $color-black;

    @include mq(ipadP) {
      max-width: 200px;
      max-height: 300px;
      margin-bottom: 10vh;
    }

    &__condition {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 60%;
      padding: 15px;

      background-color: $color-blue;
      border: solid 1px $color-black;

      transform: translate(-50%, 35%);

      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;

      p {
        margin-bottom: 10px;
      }

      img {
        display: inline-block;
        width: 35px;
      }
    }

    &__tag {
      position: absolute;
      top: 0;
      left: 50%;
      width: 80%;
      height: 50px;

      transform: translate(-50%, -50%);

      border: solid 1px $color-black;
      color: $color-white;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.1s linear 0.5s;
    }

    &__image-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: solid 1px $color-black;

      overflow: hidden;

      img {
        position: absolute;
        width: 200%;
        top: 65%;
        left: -50%;

        transform: translateY(-50%);
      }
    }

    &__arrow {
      position: absolute;
      top: 50%;
      width: 15vw;
      max-width: 60px;

      cursor: pointer;

      &--prev {
        left: 0;

        transform: translate(-75%, -50%);
      }
      &--next {
        right: 0;

        transform: translate(75%, -50%);
      }

      @include mq($and: $is-not-touch-device) {
        img {
          transition: transform 0.35s ease-out;
        }

        &.slider__arrow--prev:hover img {
          transform: translateX(-10px);
        }
        &.slider__arrow--next:hover img {
          transform: translateX(10px);
        }
      }
    }
  }
}
</style>
